import request from '@comm/utils/request'

/**
 * 文件上传
 * @param {*} data
 * @returns
 */
export function issueUploadFile(data) {
	return request({
		url: "/pubelec/api/template_compose/upload/v1",
		method: "post",
		headers: {
			"Content-Type": "multipart/form-data"
		},
		data
	});
}

/**
 * 通过模板合成凭证
 * @param {*} data
 * @returns
 */
export function compoundByTemplate(params,isUpload) {
	return request({
		url: `/pubelec/api/template_compose/compose/${isUpload?'':'example/'}v1`,
		method: "get",
		params
	});
}

/**
 * OFD下载
 * @param {*} data
 * @returns
 */
export function downloadOFD(params,isUpload) {
	return request({
		url: `/pubelec/api/template_compose/download_ofd/${isUpload?'':'example/'}v1`,
		method: "get",
		responseType: "blob",
		params
	});
}

/**
 * 通过模板合成凭证
 * @param {*} data
 * @returns
 */
export function downloadPDF(params,isUpload) {
	return request({
		url: `/pubelec/api/template_compose/download_pdf/${isUpload?'':'example/'}v1`,
		method: "get",
		responseType: "blob",
		params
	});
}

/**
 * xml模板下载
 * @param {*} data
 * @returns
 */
export function downloadXML(params) {
	return request({
		url: "/pubelec/api/template_compose/download_xml/v1",
		method: "get",
		responseType: "blob",
		params
	});
}



// WEBPACK FOOTER //
// ./src/comm/api/document-conversion/issue.js